import React, { useEffect, useState } from 'react';
import {
  buildQuerySummary,
  QuerySummary as HeadlessQuerySummary,
  SearchEngine,
} from '@coveo/headless';
import { useCoveoEngine } from 'lib/utils/coveo/SearchContext/CoveoEngineContext';
import useDictionary from 'lib/hooks/useDictionary';

type QuerySummaryProps = {
  className?: string;
  //engine?: SearchEngine;
};

export const QuerySummary: React.FC<QuerySummaryProps> = ({ className }) => {
  const engine: SearchEngine | null = useCoveoEngine();
  const [state, setState] = useState<HeadlessQuerySummary['state']>();
  const { getDictionaryValue } = useDictionary();

  useEffect(() => {
    if (!engine) return;
    const querySummary = buildQuerySummary(engine);
    setState(querySummary.state);

    const unsubscribe = querySummary.subscribe(() => {
      setState(querySummary.state);
    });

    return unsubscribe;
  }, [engine]);

  if (!state || !state.hasResults) {
    return null;
  }
  {
    /* use _firstResult and _lastResult to show pagination result count  */
  }
  //const { _firstResult, _lastResult, total, hasQuery, query } = state;
  const { total, hasQuery, query } = state;

  return (
    <div
      className={
        className || 'text-20 text-gray-900 font-nunitoSans leading-[25px] mb-5 lg:mb-0 flex'
      }
      aria-live="polite"
    >
      <span className="font-bold">{total}</span>{' '}
      <span className="pl-2">{getDictionaryValue('Results')}</span>
      {hasQuery && query?.trim().length > 0 && (
        <div className="pl-2">
          {getDictionaryValue('For')} <span className="font-bold">{query}</span>
        </div>
      )}
    </div>
  );
};

export default QuerySummary;
